<template>
  <div class="msgbox">
    <div class="msgbox-header">
        <div class="msgbox-title">{{ isEn ? 'Notice' : '提示' }}</div>
    </div>
    <div class="msgbox-content">
        <div class="msgbox-message">{{msg}}</div>
    </div>
    <div class="msgbox-btns">
        <button class="msgbox-btn msgbox-confirm" @click="close">{{ isEn ? 'OK' : '确定' }}</button>
    </div>
  </div>
</template>
<script>

export default {
    props: ['msg', 'isEn'],
    mounted() {
      console.log(this.msg);
    },
    methods: {
      close() {
        this.$emit('close');
      }
    }
  }
</script>
<style rel="stylesheet/stylus" lang="stylus" scoped>
  .msgbox {
    background-color: #fff;
    width: 6.50rem;
    border-radius: 0.03rem;
    -webkit-user-select: none;
    transition: .2s;
    text-align center

    &-header {
      padding: 0.2rem 0 0;
      color: #484848;
      font-size: 0.30rem;
      letter-spacing 0.1rem
    }

    &-content {
      padding: 0.30rem 0.20rem 0.15rem;
      border-bottom: 0.01rem solid #ddd; /*no*/
      min-height: 1.20rem;
      color: grey;
      position: relative;
      font-size: 0.20rem;
      word-wrap: break-word;
    }

    &-btns {
      height: 0.70rem;
      text-align: center;
    }

    &-confirm {
      color: rgb(38,114,255);
      width: 100%;
    }

    &-btn {
      display: block;
      background-color: #fff;
      margin: 0;
      border: 0;
      font-size: 0.28rem;
      line-height: 0.70rem;
      letter-spacing 0.1rem
    }
  }
</style>